import React, { useState } from 'react';
import { Controller, Control } from 'react-hook-form';
import { HiEye, HiEyeOff } from 'react-icons/hi';

interface BITextInputProps {
  name: string;
  control: Control<any>;
  type: 'text' | 'number' | 'email' | 'password';
  placeholder?: string;
  label?: string;
  defaultValue?: string | number;
  rules?: any;
  showLabel?: boolean;
}

const BITextInput: React.FC<BITextInputProps> = ({
  name,
  control,
  type,
  placeholder,
  label,
  defaultValue = '',
  rules,
  showLabel = true
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <div className="w-full">
      {showLabel && label && <label htmlFor={name}>{label}</label>}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <div>
            <div className='flex justify-between items-center w-full bg-white border-b-2 border-yellow-400  text-gray-700'>
              <input
                type={type === 'password' && isPasswordVisible ? 'text' : type}
                placeholder={placeholder}
                value={field.value}
                onChange={field.onChange}
                className="focus:outline-none focus:ring-none"
              />
              {type === 'password' &&  (
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="text-gray-600"
                >
                  {isPasswordVisible ? <HiEyeOff size={20} /> : <HiEye size={20} />}
                </button>
              )}

            </div>
            {error && <p className="text-red-500 text-[12px]">{error.message}</p>}
          </div>
        )}
      />
    </div>
  );
};

export default BITextInput;
